import { urls } from "@courses-pm2/api/src/ts/config";

/**
 * Helper that'll resolve the absolute url to a media file that's hosted in the
 * pm2 backend.
 */
export function resolveMediaPath(path: string): string;
export function resolveMediaPath(path: undefined | null): undefined;
export function resolveMediaPath(path: string | undefined | null): string | undefined;
export function resolveMediaPath(path: string | undefined | null): string | undefined {
    if (!path) {
        return undefined;
    }

    return `${urls.pm2Media}/${path.replace(/^\//, "")}`;
}
